export default __webpack_public_path__ + "static/media/clinic5.da5e97d9.jpg";